import { useState } from 'react';
import translator from '@Components/Utilities/Translator';
import WebSavedSearchesList from '@Components/WebSavedSearches/WebSavedSearchesList';
import { sandhillsRequest } from '@Components/Utilities/SandhillsUtility';
import LoadingRing from '@Components/MuiWrappers/LoadingRing';
import atoms from '@Components/Utilities/SandhillsAtoms';
import { useRecoilValue } from 'recoil';

const WebSavedSearches = (props) => {

    const [webSavedSearches, setWebSavedSearches] = useState(props.WebSavedSearches || []);
    const [message, setMessage] = useState(props.Message);   
    const [loading, setLoading] = useState(false);
    const routes = useRecoilValue(atoms.routes);

    const getWebSavedSearches = () => {
        sandhillsRequest({
            url: routes.GetWebSavedSearchesForCurrentUser,
            errorHandling: {
                message: 'An error occured while trying to retrieve saved searches. Please refresh your page and try again.',
                useConsole: false,
                useAlert: true
            }
        }).then((response) => {
            if (response && response.length > 0) {
                setWebSavedSearches(response);
            }
            else {
                setMessage(translator.translate('sandhills.nosearchessaved'));
            }
            setLoading(false);
        }).catch(() => {
            setLoading(false);
        });
    };

    const removeWebSavedSearch = (id) => {
        setLoading(true);
        sandhillsRequest({
            url: routes.DeleteWebSavedSearch,
            method: 'post',
            data: { webSavedSearchID: id },
            errorHandling: {
                message: 'An error occured while trying to delete your saved search. Please refresh your page and try again.',
                useConsole: false,
                useAlert: true
            }
        }).then((response) => {
            if (response.Success) {
                setMessage("Search Successfully Deleted");
                getWebSavedSearches();
            }
        }).catch(() => {
            setLoading(false);
        });
    };
    const updateWebSavedSearch = (id, newName) => {
        let webSavedSearchModel = {
            SearchName: newName,
            WebSavedSearchID: id
        };
        sandhillsRequest({
            url: routes.SaveWebSavedSearch,
            method: 'post',
            data: webSavedSearchModel,
            errorHandling: {
                message: 'An error occured while trying to update your search. Please refresh your page and try again.',
                useConsole: false,
                useAlert: true
            }
        }).then((response) => {
            if (response.Success) {
                getWebSavedSearches();
            }
        });
    }

    return (
        <>
            {loading && <LoadingRing sxBox={{ 'justify-content': 'center' }} backdrop />}
            <div className='saved-searches'>
                <h3 className="saved-searches__header mobile-hide">{translator.translate('sandhills.savedsearches')}</h3>
                <WebSavedSearchesList {...props} WebSavedSearches={webSavedSearches}
                    removeWebSavedSearch={removeWebSavedSearch} updateWebSavedSearch={updateWebSavedSearch} Message={message} />
            </div>
        </>
    );
};

export default WebSavedSearches;
